import { render, staticRenderFns } from "./SubscriptionLegalNotice.vue?vue&type=template&id=6208e5ae&scoped=true&"
import script from "./SubscriptionLegalNotice.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionLegalNotice.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionLegalNotice.vue?vue&type=style&index=0&id=6208e5ae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6208e5ae",
  null
  
)

export default component.exports